import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { DEFAULT_LANGUAGE } from '@transsion/hotent-ui/packages/Language'

Vue.use(VueI18n)

const i18n = new VueI18n({
  messages: {},
  silentTranslationWarn: true, // 去除国际化警告
  fallbackLocale: DEFAULT_LANGUAGE, // 回退语言
})

// 动态加载语言包函数
export const loadLanguageAsync = async (lang) => {
  try {
    // 动态导入语言包
    const messages = await import(
      /* webpackChunkName: "lang" */ `./lang/${lang}.js`
    )

    // 设置语言包
    i18n.setLocaleMessage(lang, messages.default || messages)

    return Promise.resolve()
  } catch (error) {
    console.error(`Failed to load language: ${lang}`, error)
    // 如果加载失败，回退到默认语言
    return loadLanguageAsync(DEFAULT_LANGUAGE)
  }
}

export default i18n
